import synchronousStateManager from './state_managers/synchronous'
import withThunkHandler from './state_managers/with_thunk'
import snap from './snap'

export default {
  synchronousStateManager,
  withThunkHandler,
  snap
}